import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // you can change to "auto" if you don’t want smooth scrolling
    });
  }, [pathname]);

  return null;
}
